import { useState } from "react";
import { FormInput } from "../Component/FormInput";
import Name from "../assets/firstName.png";
import Phone from "../assets/Phone.png";
import { useNavigate } from "react-router-dom";
import ProgressHeader from "../Component/ProgressHeader";
import { useFormData } from "../Context/FormContext";

export const EmergencyContact = () => {
  const { formData, setFormData } = useFormData();
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "emergencyContactFirstName":
      // case "emergencyContactLastName":
        if (!value.trim()) {
          error = "This field is required";
        } else if (!/^[A-Za-z\s]+$/.test(value)) {
          error = "Only letters are allowed";
        }
        break;

      case "emergencyContactRelationship":
        if (!value.trim()) {
          error = "Relationship is required";
        } else if (!/^[A-Za-z\s]+$/.test(value)) {
          error = "Only letters are allowed in relationship";
        }
        break;

      case "emergencyContactPhoneNumber":
        if (!value.trim()) {
          error = "Emergency contact phone number is required";
        }
        break;

      default:
        break;
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let newValue = value;

    // if (name === "emergencyContactPhoneNumber") {
    //   newValue = value.replace(/\D/g, "").slice(0, 10);
    // }

    setFormData((prev) => ({
      ...prev,
      emergencyDetails: { ...prev.emergencyDetails, [name]: newValue },
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: validateField(name, newValue),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    Object.entries(formData.emergencyDetails).forEach(([key, value]) => {
      const errorMsg = validateField(key, value);
      if (errorMsg) newErrors[key] = errorMsg;
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      console.log("hi")
      navigate("/registration/medicalinformation");
    }
  };

  return (
    <div className="bg-[#0C0C0C] flex justify-center p-4 pt-12">
      <ProgressHeader
        title="EMERGENCY"
        nextTitle="CONTACT INFORMATION"
        currentStep={2}
        totalSteps={4}
      />
      <form
        onSubmit={handleSubmit}
        className="bg-[#0C0C0C] w-full px-4 lg:mx-12 xl:mx-24 p-6 md:grid md:grid-cols-2 gap-x-6 lg:gap-x-32 gap-y-8 text-[16px] lg:text-[20px] font-lufga text-white"
      >
        <div className="space-y-2 mt-2">
          <FormInput
            label="Emergency Contact Name"
            placeholder="Enter Contact name..."
            name="emergencyContactFirstName"
            onChange={handleChange}
            value={formData.emergencyDetails.emergencyContactFirstName || ""}
            icon={Name}
          />
          {errors.emergencyContactFirstName && (
            <p className="text-red-500 text-sm">{errors.emergencyContactFirstName}</p>
          )}
        </div>

        {/* <div className="space-y-2 mt-2">
          <FormInput
            label="Emergency Contact Last Name"
            placeholder="Enter last name..."
            name="emergencyContactLastName"
            onChange={handleChange}
            value={formData.emergencyDetails.emergencyContactLastName || ""}
            icon={Name}
          />
          {errors.emergencyContactLastName && (
            <p className="text-red-500 text-sm">{errors.emergencyContactLastName}</p>
          )}
        </div> */}

        <div className="space-y-2 mt-2">
          <FormInput
            label="Relationship"
            placeholder="Enter relationship..."
            name="emergencyContactRelationship"
            onChange={handleChange}
            value={formData.emergencyDetails.emergencyContactRelationship || ""}
            icon={Name}
          />
          {errors.emergencyContactRelationship && (
            <p className="text-red-500 text-sm">{errors.emergencyContactRelationship}</p>
          )}
        </div>

        <div className="space-y-2 mt-2">
          <FormInput
            label="Emergency Contact Phone Number"
			      // type="number"
            placeholder="(000) 000-0000"
            name="emergencyContactPhoneNumber"
            onChange={handleChange}
            value={formData.emergencyDetails.emergencyContactPhoneNumber || ""}
            icon={Phone}
            onKeyPress={(e) => {  if (!/[0-9]/.test(e.key)) { e.preventDefault()}}}
          />
          {errors.emergencyContactPhoneNumber && (
            <p className="text-red-500 text-sm">{errors.emergencyContactPhoneNumber}</p>
          )}
        </div>

        <div className="col-span-2 flex flex-row justify-center gap-4 md:gap-6 mt-12 ">
          <button
            type="button"
            onClick={() => navigate("/registration/personalinformation")}
            className="cursor-pointer px-10 border border-solid border-[#D3631D] text-white bg-[#0c0c0c] py-2 rounded-full text-[24px] md:text-[30px] font-league transition-colors duration-300 w-full md:w-auto"
          >
            BACK
          </button>
          <button
            type="submit"
            className="bg-[#D3631D] border-none cursor-pointer text-white px-10 py-2 rounded-full text-[24px] md:text-[30px] font-league transition-colors duration-300 w-full md:w-auto"
          >
            NEXT
          </button>
        </div>
      </form>
    </div>
  );
};
